import { toISODate } from './crmDates'

// A manually recorded CrmVehicle reshaped into the quote object QuoteCard
// renders, so an owned car reads like the sold cars beside it. The sibling of
// wonOppToQuote — that one adapts a WON opportunity, this one a vehicle the rep
// entered by hand. Neither knows about the other.

// A date-only 'YYYY-MM-DD' must not go through `new Date(iso)`, which parses it
// as UTC midnight and renders the previous day west of Greenwich. Splitting the
// parts builds it in local time instead. Opportunity's datetime fields keep
// their own handling; this is not a global date change.
export const parseDateOnly = (raw) => {
    if (!raw) return null
    const [y, m, d] = String(raw).split('-').map(Number)
    if (!y || !m || !d) return null
    const date = new Date(y, m - 1, d)
    return Number.isNaN(date.getTime()) ? null : date
}

// Where the term stands, in the same words the sold cards beside it use.
export const getVehicleExpiry = (expirationDate) => {
    const end = parseDateOnly(expirationDate)
    if (!end) return { label: 'Active', expired: false }
    const expired = end.getTime() < Date.now()
    const when = end.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
    return { label: `${expired ? 'Expired' : 'Expires'} ${when}`, expired }
}

export const vehicleToQuote = (vehicle) => {
    const title = [vehicle?.year, vehicle?.make, vehicle?.model]
        .filter(Boolean)
        .join(' ')

    return {
        // No worksheet behind a hand-entered car, so the card stays inert
        // rather than opening someone else's deal.
        id: null,
        // A car with nothing filled in is still a car — never "New quote".
        description: title || 'Vehicle',
        // The trim reads on its own line under the name, as it does on a sold
        // car, where it is the pinned deal's spec.
        spec: vehicle?.trim || null,
        // Ownership, and only what the rep recorded: a blank one means they
        // never said, and an unknown car must not be drawn as a lease.
        deal_type: vehicle?.ownership_type || null,
        vin: vehicle?.vin || null,
        // Already the ISO day the DateField stores; toISODate keeps a legacy
        // MM/DD/YYYY readable too, and neither goes through new Date().
        exp: toISODate(vehicle?.expiration_date) || null,
        // Nobody records a sticker price for a car they already own.
        msrp: null,
        // A real odometer reading, unlike a sold lease's annual allowance.
        // `?? null` so a recorded 0 stays 0 and only unknown reads as unknown.
        odo: vehicle?.mileage ?? null,
        payoff: vehicle?.payoff ?? null,
    }
}
